import * as React from 'react'
import { useContext, useState } from 'react'
import { AppContext } from './appcontext'
import { cuttingSteps } from "../models/cuttingsteps"


export function CuttingSteps(props: {}) {

    const [step, setStep] = useState(1)
    var ctx = useContext(AppContext)

    function next() {
        if (step == 9)
            return;

        setStep(step + 1)
    }

    function prev() {
        if (step == 1)
            return;

        setStep(step - 1)
    }

    var images = cuttingSteps.filter(cs => cs.step).map(cs => <div style={{ marginBottom: '5px' }}><img className="rounded-lg shadow-lg mt-4" width="400" src={`${ctx.root}/images/${cs.img}`} /></div>)


    return <div className="px-2">

        <div className="embed-responsive embed-responsive-4by3 relative w-full overflow-hidden rounded-lg" style={{ paddingTop: "75%" }}>
            <iframe
                className="embed-responsive-item absolute bottom-0 left-0 right-0 top-0 h-full w-full"
                src="https://www.youtube.com/embed/RJI6PH5bJyI"
                allowFullScreen={true}
                data-gtm-yt-inspected-2340190_699="true"
                id="240632615"></iframe>
        </div>
        <div className="w-full flex flex-col items-center">
            {images}
        </div>
    </div>
}